import {mapMutations, mapGetters, mapActions} from "vuex";
import {required, minLength, sameAs} from 'vuelidate/lib/validators'

export default {
    name: "new-password",
    data() {
        return {
            isRegister: false,
            payload: {
                password_confirmation: '',
                password: '',
                token: '',
                email: ''
            },
            submitted: false,

        }
    },
    created() {

        this.changeShowPopUpLogin(false)
    },
    validations: {
        payload: {
            password: {required, minLength: minLength(8)},
            password_confirmation: {required, sameAsPassword: sameAs('password')}
        }
    },
    methods: {
        ...mapMutations({
            changeShowPopUpNewPassword: 'auth/CHANGE_POPUP_NEW_PASSWORD',
            changeShowPopUpNewPasswordSuccess: 'auth/CHANGE_POPUP_PASSWORD_SUCCESS',
            changeShowPopUpPasswordEmail: 'auth/CHANGE_POPUP_PASSWORD_EMAIL',
            changeShowPopUpLogin: 'auth/CHANGE_POPUP_LOGIN',

        }),
        ...mapActions({
            sendPassword: 'auth/NEW_PASSWORD'
        }),
        send() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                this.payload.token = this.$route.query.token
                this.payload.email = this.$route.query.email
                this.sendPassword(this.payload).then(() => {
                    this.changeShowPopUpNewPassword(false)
                    this.changeShowPopUpNewPasswordSuccess(true)
                }).catch((error) => {
                    console.log(error)
                })

            }
        }


    },
    computed: {
        ...mapGetters({
            showPopUpNewPassword: 'auth/showPopUpNewPassword'
        }),
    }
}

